import { render } from "./AddSectionControl.vue?vue&type=template&id=f6295f08"
import script from "./AddSectionControl.vue?vue&type=script&lang=js"
export * from "./AddSectionControl.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__